<template>
  <div class="app">
    <div v-if="showCookie" class="cookie">
      <div class="cookie__inner">
        <div class="cookie__text">
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15.9987 26.6654C21.8897 26.6654 26.6654 21.8897 26.6654 15.9987C26.6654 10.1077 21.8897 5.33203 15.9987 5.33203C10.1077 5.33203 5.33203 10.1077 5.33203 15.9987C5.33203 21.8897 10.1077 26.6654 15.9987 26.6654Z"
              stroke="white"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M16.0118 20.0001L16.0141 16"
              stroke="white"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M16 12.668L16 12.0013"
              stroke="white"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <p>
            האתר/מערכת עושה שימוש ב-cookies. כדי לספק לך חווית גלישה טובה יותר,
            וכן למטרות סטטיסטיקה, איפיון ושיפורים.
          </p>
          <p>
            למידע על cookies ועל מדיניות הפרטיות המעודכנת
            <a href="https://www.smart-campus.co.il/privacy/" target="_blank"
              >יש ללחוץ כאן</a
            >.
          </p>
        </div>
        <a
          href=""
          class="btn btn--border-white btn--static-lg"
          @click.prevent="hideCookie"
        >
          <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11 1L1 11"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M1 1L11 11"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          סגור
        </a>
      </div>
    </div>
    <pwa v-if="showPwa" />
    <passkey-prompt v-if="authenticated" :key="'pk-' + authenticated" />

    <component
      :is="layout"
      v-if="
        layout === 'auth-layout' || layout === 'guest-layout'
          ? true
          : selectedCampus
      "
      :class="{ 'show-pwa': showPwa }"
    >
      <router-view v-show="loaded" />
    </component>
  </div>
</template>

<script>
import store from './Store/index';
import router from './Router/index';
import axios from 'axios';
import { mapGetters, mapMutations, mapState } from 'vuex';
import LayoutDefault from './Components/Layout/LayoutDefault';
import AuthLayout from './Components/Layout/AuthLayout';
import GuestLayout from './Components/Layout/GuestLayout.vue';
import StudentLayout from './Pages/Student/Blocks/StudentLayout';
import LessonsPdf from '@/Components/Layout/LessonsPdf';
import Pwa from './Components/Pwa';
import PasskeyPrompt from '@/Components/PasskeyPrompt';

export default {
  name: 'App',
  components: {
    LayoutDefault,
    StudentLayout,
    AuthLayout,
    GuestLayout,
    LessonsPdf,
    Pwa,
    PasskeyPrompt
  },
  data() {
    return {
      // loaded: this.getLoading ? this.getLoading : false,
      loaded: true,
      vh: '',
      vw: ''
    };
  },
  computed: {
    ...mapState({
      showCookie: s => s.settings.showCookie,
      showPwa: s => s.settings.showPwa,
      selectedCampus: s => s.settings.selectedCampus
    }),
    ...mapGetters({
      authenticated: 'auth/authenticated',
      user: 'auth/user',
      getLoading: 'preloader/getLoading'
    }),
    layout() {
      return this.$route.meta.layout || 'layout-default';
    }
  },
  watch: {
    getLoading(value) {
      this.loaded = value;
    },
    $route(to, from) {
      // if (this.user && this.user.is_first_login) {
      //   this.$router.replace({
      //     name: 'FirstChangePassword'
      //   });
      // }
      /*
                                if(to.name !== from.name){
                                    this.loaded = false;
                                    setTimeout(res => {
                                        this.loaded = true;
                                    }, 500);
                                }
                */
    }
  },
  mounted() {
    this.vh = window.innerHeight * 0.01;
    this.vw = window.innerWidth * 0.01;

    document.documentElement.style.setProperty('--vh', `${this.vh}px`);
    document.documentElement.style.setProperty('--vw', `${this.vw}px`);

    if (this.user && (this.user.is_first_login || this.user.password_expired)) {
      this.$router.replace({
        name: 'FirstChangePassword'
      });
    }
    // A 401 means the server no longer knows this session. Sign out
    // ONCE (parallel requests all fail together) and only if we were
    // signed in — a guest on the login page must not fire /logout,
    // which would rotate the freshly created session under their
    // feet. Navigate to the login page after the server has answered,
    // so the page starts with a stable session and CSRF token.
    //
    // One 401 is different: `two_factor_pending` — the password was
    // accepted and the server is waiting for the code (typically a
    // reload of the code screen). That session is alive and must not
    // be logged out; stay on / return to the code screen instead.
    //
    // The public lesson page (OpenPageLessonGroupEdit) is used by guests
    // and gets 401s by design — never redirect from there.
    let signingOut = null;
    axios.interceptors.response.use(undefined, function (err) {
      const status = err && err.response && err.response.status;
      const data = (err && err.response && err.response.data) || {};
      if (status === 401 && data.two_factor_pending) {
        store.commit('auth/SET_PENDING_EXPIRES_IN', data.expires_in);
        if (router.currentRoute.name !== 'Confirm') {
          router.replace({ name: 'Confirm' }).catch(() => {});
        }
        throw err;
      }
      if (
        status === 401 &&
        router.currentRoute.name !== 'OpenPageLessonGroupEdit'
      ) {
        if (store.getters['auth/authenticated'] && !signingOut) {
          signingOut = store
            .dispatch('auth/logOut')
            .catch(() => {})
            .then(() => {
              signingOut = null;
              router.push({ name: 'SignIn' }).catch(() => {});
            });
        } else if (!store.getters['auth/authenticated'] && !signingOut) {
          router.push({ name: 'SignIn' }).catch(() => {});
        }
      }
      throw err;
    });
  },
  methods: {
    ...mapMutations({
      hideCookie: 'settings/HIDE_COOKIE'
    })
  }
};
</script>
<style>
[v-cloak] {
  display: none;
}
</style>
